import React, { useEffect, useState } from 'react'
import Breadcrum from '../../components/common/Breadcrum';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { callDetailByPhone } from '../../redux/slices/callCollectionSlice';
import EmployeeCallAnalysis from './EmployeeCallAnalysis';
import EmployeeCallDetails from './EmployeeCallDetails';

export default function EmployeeCallHistoryDetails() {
  const [activeTab, setActiveTab] = React.useState(0);
     const dispatch = useDispatch();
     const [notesData, setNotesData] = useState([]);
    const location = useLocation();
    const callId = location.pathname.split('/').pop(); // Extracting the call ID from the URL
    
    const breadcrumbItems = [
         { label: 'Calls History', path: '/employee/calls-history' },
        { label: `${callId}`, path: '/employee/calls-history/detail' }
  ];
    const tabs = [
      {
        id: 0,
        label: 'Analysis',
      },
      {
        id: 1,
        label: 'Full History',
      }
    ]
  return (
   <>
    <div className='bg-gray-200 dark:bg-gray-800 py-2 px-4 rounded-lg flex justify-between items-center'>
           <div>
             <h1 className='text-2xl font-semibold text-theme-dark dark:text-theme-light'>{breadcrumbItems[0].label}</h1>
             <Breadcrum items={breadcrumbItems} />
           </div>
         </div>
         <div className="mt-5 mb-0">
          {
            tabs.length > 0 && tabs.map((tab)=>(
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-4 py-2 mr-2 rounded-lg ${activeTab === tab.id ? 'bg-blue-500 text-white' : 'bg-gray-300 dark:bg-gray-700 text-gray-800 dark:text-gray-200'}`}
              >
                {tab.label}
              </button>
            ))
          }
         </div>
         <div className='  '>
          {activeTab === 0 && <EmployeeCallAnalysis id={callId} />}
          {activeTab === 1 && <EmployeeCallDetails id={callId} />}
         </div>
   </>
  )
}
